import Big from 'big.js';

const bp = (v) => new Big(v || 0);

const ZERO = () => new Big(0);

/**
 * Aggregate load-balance rows into per-game invoice totals.
 * Mirrors POS statement categorization in campaignController.
 */
export function accumulateInvoiceFromLoadBalance(data = []) {
  const result = (data || []).reduce(
    (acc, item) => {
      const pts = bp(item.points);
      if (item.narration === 'Campaign Purchase') {
        acc.lottoSales = acc.lottoSales.plus(pts);
      } else if (item.narration === 'Campaign Commission') {
        acc.lottoCommission = acc.lottoCommission.plus(pts);
      } else if (item.narration === 'Campaign Purchase Cancel') {
        acc.lottoCancel = acc.lottoCancel.plus(pts);
      } else if (item.narration === 'Campaign Commission Reverse') {
        acc.lottoCommissionReverse = acc.lottoCommissionReverse.plus(pts);
      } else if (item.narration === 'Lotto Winner Redeem') {
        acc.lottoAmountPaid = acc.lottoAmountPaid.plus(pts);
      } else if (item.narration === 'Reverse Lotto Winner Redeem') {
        acc.lottoAmountPaid = acc.lottoAmountPaid.minus(pts);
      } else if (item.narration === 'Voucher Purchase') {
        acc.voucherSales = acc.voucherSales.plus(pts);
      } else if (item.narration === 'Voucher Commission') {
        acc.voucherCommission = acc.voucherCommission.plus(pts);
      } else if (item.narration === 'Voucher Order Cancel') {
        acc.voucherCancel = acc.voucherCancel.plus(pts);
      } else if (item.narration === 'Voucher Commission Reverse') {
        acc.voucherCommissionReverse = acc.voucherCommissionReverse.plus(pts);
      } else if (item.narration === 'Product Order') {
        acc.e_commSales = acc.e_commSales.plus(pts);
      } else if (item.narration === 'Product Cancel') {
        acc.e_commCancel = acc.e_commCancel.plus(pts);
      } else if (item.narration === 'Smart RTP Purchase') {
        acc.rtpSales = acc.rtpSales.plus(pts);
      } else if (item.narration === 'Smart RTP Commission') {
        acc.rtpCommission = acc.rtpCommission.plus(pts);
      } else if (item.narration === 'Smart RTP Purchase Cancel') {
        acc.rtpCancel = acc.rtpCancel.plus(pts);
      } else if (item.narration === 'Smart RTP Commission Reverse') {
        acc.rtpCommissionReverse = acc.rtpCommissionReverse.plus(pts);
      } else if (
        item.narration === 'Smart RTP Reward Redeem' ||
        item.narration === 'Smart RTP Winner Redeem'
      ) {
        acc.rtpAmountPaid = acc.rtpAmountPaid.plus(pts);
      } else if (item.narration === 'Smart RTP Reverse Winner Redeem') {
        acc.rtpAmountPaid = acc.rtpAmountPaid.minus(pts);
      }
      return acc;
    },
    {
      lottoSales: ZERO(),
      lottoCommission: ZERO(),
      lottoCancel: ZERO(),
      lottoCommissionReverse: ZERO(),
      lottoAmountPaid: ZERO(),
      voucherSales: ZERO(),
      voucherCommission: ZERO(),
      voucherCancel: ZERO(),
      voucherCommissionReverse: ZERO(),
      e_commSales: ZERO(),
      e_commCancel: ZERO(),
      rtpSales: ZERO(),
      rtpCommission: ZERO(),
      rtpCancel: ZERO(),
      rtpCommissionReverse: ZERO(),
      rtpAmountPaid: ZERO(),
    }
  );

  const totalLottoSales = result.lottoSales.minus(result.lottoCancel);
  const totalLottoCommission = result.lottoCommission.minus(result.lottoCommissionReverse);
  const totalVoucherSales = result.voucherSales.minus(result.voucherCancel);
  const totalVoucherCommission = result.voucherCommission.minus(result.voucherCommissionReverse);
  const totalE_commSales = result.e_commSales.minus(result.e_commCancel);
  const totalRtpSales = result.rtpSales.minus(result.rtpCancel);
  const totalRtpCommission = result.rtpCommission.minus(result.rtpCommissionReverse);

  const totalSalesAmount = totalLottoSales
    .plus(totalVoucherSales)
    .plus(totalE_commSales)
    .plus(totalRtpSales);
  const totalCommissionAmount = totalLottoCommission
    .plus(totalVoucherCommission)
    .plus(totalRtpCommission);
  const totalPaidAmount = result.lottoAmountPaid.plus(result.rtpAmountPaid);

  return {
    totalLottoSales,
    totalLottoCommission,
    lottoAmountPaid: result.lottoAmountPaid,
    totalVoucherSales,
    totalVoucherCommission,
    totalE_commSales,
    totalRtpSales,
    totalRtpCommission,
    rtpAmountPaid: result.rtpAmountPaid,
    totalSalesAmount,
    totalCommissionAmount,
    totalPaidAmount,
  };
}
